import { featureFlagsInitialState } from 'src/constants/constants';

export const SET_ADMIN_FEATURE_FLAGS = 'SET_ADMIN_FEATURE_FLAGS';
export const setAdminFeatureFlags = (featureFlags: any) => ({
  type: SET_ADMIN_FEATURE_FLAGS,
  payload: featureFlags,
});

const initialState: any = { ...featureFlagsInitialState };

interface Action {
  type: string;
  payload: any;
}

const adminFeatureFlagsReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case SET_ADMIN_FEATURE_FLAGS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
export default adminFeatureFlagsReducer;
